import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as CapacityChangeActions from "../../store/actions/CapacityChange";
import * as UserActions from "../../store/actions/User";
import { bindActionCreators } from "redux";
import { getSlotsList, resetStateSlot } from "../../store/actions/Slots";
import FilterButton from "../../components/Common/FilterButton";
import { CAPACITY_CHANGE_TABS } from "../../views/GigsCapacityChange";
import Button from "sushiweb/Button";
import ViewFilters from "./ViewFilters";
import ViewTab from "./ViewTab";
import CreateFilters from "./CreateFilters";
import CreateTab from "./CreateTab";
import { isValNull, removeEmptyVals } from "../../utils";

const CapacityChange = ({
  defaultPage,
  getSlotsList,
  slotData,
  fetchCapacityChangeRequests,
  activeFilters,
  userAttributes,
  capacityChangeRequests,
  carrierList,
  resetStateSlot,
  createCapacityChangeRequest,
}) => {
  const [viewTabSelected, selectViewTab] = useState(false);
  const [isFilterSelected, setFilterScreen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entityId, setEntityId] = useState("");

  useEffect(() => {
    if (defaultPage == CAPACITY_CHANGE_TABS.approve) {
      selectViewTab(true);
    }
  }, [defaultPage]);

  const openCreateTab = (action) => {
    selectViewTab(action);
    resetStateSlot({ state: "slotsList" });
  };

  const getNotNullActiveFilters = () => {
    const filters = removeEmptyVals(activeFilters);
    if (!isValNull(filters["request_id"])) {
      return { request_id: filters["request_id"] };
    } else {
      return filters;
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "20px",
          alignItems: "center",
          height: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "10%",
          }}
        >
          <Button
            data-testid="SlotsFiltersApply"
            type="submit"
            className="sushi-btn mr-10"
            onClick={() => openCreateTab(false)}
            appearance={viewTabSelected ? "outline" : ""}
          >
            Create
          </Button>

          <Button
            data-testid="SlotsFiltersApply"
            type="submit"
            className="sushi-btn mr-10"
            onClick={() => openCreateTab(true)}
            appearance={viewTabSelected ? "" : "outline"}
          >
            View
          </Button>
        </div>
        {viewTabSelected ? (
          <FilterButton
            style={{ alignItems: "flex-end", display: "flex" }}
            activeFilters={getNotNullActiveFilters()}
            handleClick={() => setFilterScreen(!isFilterSelected)}
          />
        ) : null}
      </div>

      <hr></hr>
      {viewTabSelected ? (
        <div>
          {isFilterSelected ? (
            <ViewFilters
              handleModalClose={() => setFilterScreen(false)}
              userAttributes={userAttributes}
              getCapacityChangeRequests={fetchCapacityChangeRequests}
              carrierList={carrierList}
              activeFilters={activeFilters}
              resetPageCount={() => setCurrentPage(currentPage + 1)}
            />
          ) : null}
          <ViewTab
            page={currentPage}
            capacityChangeRequests={capacityChangeRequests}
            userAttributes={userAttributes}
            carrierList={carrierList}
            activeFilters={activeFilters}
          />
        </div>
      ) : (
        <div>
          <CreateFilters
            getSlotsList={getSlotsList}
            userAttributes={userAttributes}
            carrierList={carrierList}
            setEntityId={setEntityId}
          />
          <CreateTab
            slotData={slotData}
            entityId={entityId}
            createCapacityChangeRequest={createCapacityChangeRequest}
          />
        </div>
      )}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getSlotsList: bindActionCreators(getSlotsList, dispatch),
    fetchCapacityChangeRequests: bindActionCreators(
      CapacityChangeActions.getCapacityChangeRequestData,
      dispatch
    ),
    createCapacityChangeRequest: bindActionCreators(
      CapacityChangeActions.createCapacityChangeRequest,
      dispatch
    ),
    resetStateSlot: bindActionCreators(resetStateSlot, dispatch),
    resetState: bindActionCreators(
      CapacityChangeActions.resetCapacityState,
      dispatch
    ),
  };
}

function mapStateToProps(state) {
  const { Slots, CapacityChange } = state;
  return {
    slotData: Slots.slotsList,
    carrierList: CapacityChange.carrierList,
    capacityChangeRequests: CapacityChange.capacityChangeRequests,
    activeFilters: Slots.activeFilters,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CapacityChange);
